// History tab wrapper. The inner file renders the shared RecordHistoryTab,
// which owns the HistoryGridBox panel (BP-04, H244), so this file adds no
// panel of its own. Two panels would put a card in a card.
import { useConfig } from "../../hooks/useConfig";
import InvoiceHistory from "../InvoiceHistory";

interface InvoiceHistoryTabProps {
  invoiceId: number;
}

export default function InvoiceHistoryTab({
  invoiceId,
}: InvoiceHistoryTabProps) {
  const invoiceConfig = useConfig("invoices");
  return <InvoiceHistory invoiceId={invoiceId} invoiceConfig={invoiceConfig} />;
}
